"use client";
import SectionPage from "@/components/common/section-page";

import EspaceProTitleCard from "@/components/common/espace-pro-title-card";

export default function Home() {

    return (
        <div className={"flex flex-col gap-6 pb-6 mb-8"}>


            <EspaceProTitleCard title={"Statistiques et Suivi-Evaluation"}
                                middleBreadcrumbs={[
                                    {title: "L'Office du Tourisme", link: "/espace-pro/office-de-tourisme"},
                                ]}
                                description={"Découvrez l’équipe de l’Office de Tourisme et les missions que nous menons, en faveur du développement touristique de la destination COTE D’IVOIRE"}/>

            {/* Nature & Biodiversité */}
            <SectionPage sectionType="lg">

                <p className={"text-normal mb-8"}>
                    Directeur : Monsieur <strong>GADDAH Olivier</strong>
                    <br/>
                    <br/>
                    Il est chargé de :
                </p>

                <div className={"text-normal mb-8"}>
                    <ul className="list-disc list-inside text-lg mt-8">
                        <li className="li2">Élaborer les données statistiques nécessaires à la planification des
                            activités de Côte d’Ivoire Tourisme ;
                        </li>
                        <li className="li2">Collecter et de diffuser les données et les indicateurs statistiques
                            relatifs au secteur du Tourisme ;
                        </li>
                        <li className="li2">Produire des études et des rapports sur l’état du secteur du tourisme ;</li>
                        <li className="li2">Évaluer toutes les activités de Côte d’Ivoire Tourisme ;</li>
                        <li className="li2">Élaborer une typologie des besoins en informations du secteur du tourisme
                            pour un suivi-évaluation efficace ;
                        </li>
                        <li className="li2">Instaurer une évaluation systématique des actions, résultats et performances
                            des services.
                        </li>
                    </ul>
                </div>

            </SectionPage>

        </div>
    );
}
